var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationCircleOutlineSvgrepoCom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information-circle-outline-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.625 3C6.86203 3 3 6.86203 3 11.625C3 16.388 6.86203 20.25 11.625 20.25C16.388 20.25 20.25 16.388 20.25 11.625C20.25 6.86203 16.388 3 11.625 3Z",
    stroke: "#6D76E0",
    strokeWidth: 0.8125,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3125 10.3125H11.8125V15.75",
    stroke: "#6D76E0",
    strokeWidth: 0.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.75 15.9375H13.875",
    stroke: "#6D76E0",
    strokeWidth: 0.8125,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6272 6.09375C11.3862 6.09375 11.1505 6.16523 10.9501 6.29915C10.7497 6.43306 10.5935 6.62341 10.5012 6.8461C10.409 7.0688 10.3848 7.31385 10.4319 7.55027C10.4789 7.78668 10.595 8.00384 10.7654 8.17429C10.9359 8.34473 11.153 8.46081 11.3894 8.50783C11.6258 8.55486 11.8709 8.53072 12.0936 8.43848C12.3163 8.34623 12.5066 8.19002 12.6406 7.9896C12.7745 7.78918 12.8459 7.55355 12.8459 7.3125C12.8459 6.98927 12.7175 6.67927 12.489 6.45071C12.2604 6.22215 11.9504 6.09375 11.6272 6.09375Z",
    fill: "#6D76E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircleOutlineSvgrepoCom1);
export default __webpack_public_path__ + "static/media/information-circle-outline-svgrepo-com 1.e890ee87017228c852e7e752ab964875.svg";
export { ForwardRef as ReactComponent };